import { Injectable } from '@angular/core';
import { CustomFacet, CustomOccProductSearchPage } from '@catalog/const';
import { Converter, ConverterService, Occ, PRODUCT_NORMALIZER } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CustomOccProductSearchPageNormalizer implements Converter<
  Occ.ProductSearchPage,
  CustomOccProductSearchPage
> {
  /**
   * Specifies the minimal number of top values in case
   * non have been setup by the business.
   */
  protected DEFAULT_TOP_VALUES = 6;

  constructor(private converterService: ConverterService) {}

  convert(source: Occ.ProductSearchPage, target: CustomOccProductSearchPage): CustomOccProductSearchPage {
    if (target === undefined) {
      target = { ...source } as any;
    }

    this.normalizeFacets(target);
    if (source.products) {
      target.products = source.products.map((product) =>
        this.converterService.convert(product, PRODUCT_NORMALIZER),
      ) as any;
    }

    return target;
  }

  private normalizeFacets(target: CustomOccProductSearchPage): void {
    this.normalizeFacetValues(target);
    this.normalizeUselessFacets(target);
  }

  // Нормалайзер нужен для того, чтобы отображались фасеты
  // с только одним значением, коробочный нормалайзер его режет
  private normalizeUselessFacets(target: CustomOccProductSearchPage): void {
    target.facets = target.facets.filter((facet: CustomFacet) => {
      return (
        !target.pagination ||
        !target.pagination.totalResults ||
        facet.code === 'outOfStockFlag' ||
        facet.contentType === 'RANGE' ||
        ((!Object.prototype.hasOwnProperty.call(facet, 'visible') || facet.visible) &&
          facet.values &&
          facet.values.find((value) => {
            return value.selected || value.count <= target.pagination.totalResults;
          }))
      );
    });
  }

  /*
   * In case there are so-called `topValues` given for the facet values,
   * values are obsolete.
   *
   * `topValues` is a feature in Adaptive Search which can limit a large
   * amount of facet values to a small set (5 by default). As long as the backend
   * provides all facet values AND topValues, we normalize the data to not bother
   * the UI with this specific feature.
   */
  private normalizeFacetValues(target: CustomOccProductSearchPage): void {
    if (target.facets) {
      target.facets = target.facets.map((facetSource: CustomFacet) => {
        const { topValues, ...facetTarget } = facetSource;
        facetTarget.topValueCount = topValues?.length > 0 ? topValues.length : this.DEFAULT_TOP_VALUES;

        return facetTarget;
      });
    }
  }
}
